import { Comparator } from 'constants/filters';
import { List, Record, RecordOf } from 'immutable';
import { isNil } from 'lodash';
import { History, Location } from 'history';

export interface Filter {
  field: string;
  comparator: string;
  value: string | number | boolean;
}

export const FilterFactory = Record<Filter>({
  field: '',
  comparator: '',
  value: '',
});

const djangoFilterComparatorString = Object.values(Comparator);
const djangoFilterKeyRegex = new RegExp(
  `(?<field>^\\w+(__\\w+)*)__(?<comparator>\\!?(${djangoFilterComparatorString.join('|')}))`
);

function validateFilterQueryParam(string: string): RegExpMatchArray {
  return string.match(djangoFilterKeyRegex);
}

export function extractFiltersFromQueryParams(location: Location): Filter[] {
  const { search } = location;
  const params = new URLSearchParams(search);
  const filters: Filter[] = [];

  params.forEach((value, key) => {
    const match = validateFilterQueryParam(key);
    if (match) {
      filters.push({
        field: match.groups.field,
        comparator: match.groups.comparator,
        value: value,
      });
    }
  });

  return filters;
}

export function addFiltersToStoreFromQueryParams(
  location: Location,
  setFiltersFn: (filters: List<RecordOf<Filter>>) => void
): Filter[] {
  const filters = extractFiltersFromQueryParams(location);
  setFiltersFn(List(filters.map((filter) => FilterFactory(filter))));

  return filters;
}

export function buildURLWith(queryParams: URLSearchParams): string;
export function buildURLWith(queryParams: URLSearchParams, url?: string): string {
  let output = '';
  if (isNil(url)) {
    output = window.location.pathname;
  }
  if (queryParams.size) {
    output += `?${queryParams.toString()}`;
  }
  return output;
}

export function setFiltersQueryParams(filters: RecordOf<Filter>[], history: History) {
  const urlParams = new URLSearchParams();
  filters.forEach((filter) => {
    const { field, comparator, value } = filter.toJS();
    const key = `${field}__${comparator}`;
    urlParams.append(key, value.toString());
  });
  history.replace(buildURLWith(urlParams));
}

export function addFilterToQueryParams(filter: RecordOf<Filter>, history: History) {
  const { field, comparator, value } = filter.toJS();
  const key = `${field}__${comparator}`;
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.append(key, value.toString());
  history.replace(buildURLWith(urlParams));
}

export function removeFilterFromQueryParams(filter: RecordOf<Filter>, history: History) {
  const urlParams = new URLSearchParams(window.location.search);
  const key = `${filter.get('field')}__${filter.get('comparator')}`;
  urlParams.delete(key);
  history.replace(buildURLWith(urlParams));
}
